(function () {

  function initComplementaryCards(root = document) {

    const cards = root.querySelectorAll(
      '[data-complementary-card]:not([data-complementary-initialized])'
    );

    cards.forEach((card) => {

      card.setAttribute(
        'data-complementary-initialized',
        'true'
      );

    });

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => initComplementaryCards()
    );

  } else {

    initComplementaryCards();

  }


  document.addEventListener(
    'shopify:section:load',
    (event) => {

      initComplementaryCards(event.target);

    }
  );

})();